import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


const ArticleEmpty = () => {
  const paragraphCount = Math.floor(Math.random() * (16 - 8) + 8);

  return (
    <React.Fragment>
      <div className={classNames('title-1', 'elementDummy')} />
      {[...Array(paragraphCount)].map((item, i) => {
        const lineWidth = Math.random() * (100 - 60) + 60;
        return (
          <div className={classNames('paragraph', 'elementDummy')} key={i} style={{ width: `${lineWidth}%` }} />
        );
      })}
    </React.Fragment>
  );
};

ArticleEmpty.propTypes = {
  extraClassName: PropTypes.string,
};

export default ArticleEmpty;
